import React from 'react';
import './loaders.scss';

const FullPageLoader = () => {
    return (
        <div className="fullPageWrap">
            <div className="fullPageLoader"></div>
        </div>
    );
};

export default FullPageLoader;
